export const github = 'https://github.com/StTronn'
export const twitter = 'https://twitter.com/st_tronn'
export const linkedin = 'https://www.linkedin.com/in/rishav-thakur-413b38a1/'
